var render = function render(_c,_vm){return _c('div',{staticClass:"field-rich-text--preview grid-view__cell grid-field-rich-text__cell"},[_c('div',{staticClass:"grid-field-rich-text__cell-content grid-field-rich-text__cell-content--preview",domProps:{"innerHTML":_vm._s(_vm.$options.methods.renderFormattedValue(_vm.parent, _vm.props))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }